export default "__VITE_ASSET__8K9AeROL__"